import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { ServiceAreasList } from '@trashlab/sitesapp/src/organizations/piedmont/template/components/service-areas/service-list';
import { FAQ } from '@trashlab/sitesapp/src/organizations/piedmont/template/components/shared/faq-section';
import { RequestServiceForm } from '@trashlab/sitesapp/src/organizations/piedmont/template/components/request-service/request-service-form';
import { HeroSection } from '@trashlab/sitesapp/src/organizations/piedmont/template/components/shared/hero-section';
import { CommunityServiceSection } from '@trashlab/sitesapp/src/organizations/piedmont/template/components/service-areas/community-service-section';
import { CtaSection } from '@trashlab/sitesapp/src/organizations/piedmont/template/components/shared/cta-section';
import { useTenantContext } from '@trashlab/sitesapp/src/organizations/piedmont/contexts/use-tenant-context';
import { useVariantValue } from '@trashlab/sitesapp/src/organizations/piedmont/lib/utils/get-variant-value';
import { asAddress } from '@trashlab/api/src/library/server/utils/json-compatibility';

const ServiceAreasPage = () => {
  const { website } = useTenantContext();
  const orgAddress = asAddress(website?.organization?.address as any);
  const city = orgAddress?.city ?? 'San Francisco';
  const state = orgAddress?.state ?? 'CA';

  const serviceAreaHeroSubtitle = useVariantValue(
    'SERVICE_AREA_HERO_SUBTITLE',
    `${
      website?.organization?.name || 'Our company'
    } covers a wide area of the Salt Lake and its surrounding communities, including areas such as ${city}, ${state} and more. Use our service map tool, or get your questions answered in regards to our service area capabilities.`,
  );

  const customSubtitle = useVariantValue(
    'CONTACT_TITLE',
    'Still have questions about our service area?',
  );
  const customDescription = useVariantValue(
    'CONTACT_SUBTITLE',
    'If you still have questions or concerns in regards to our service area and the services we provide, please do not hesitate to fill out the form below to have your question answered. Thank you!',
  );

  return (
    <>
      <HeroSection title="Service Area" content={serviceAreaHeroSubtitle} />
      <ServiceAreasList />
      <CommunityServiceSection />
      <FAQ accordionOnly faqType="home" />
      <RequestServiceForm
        customTitle="Do you have questions?"
        customDescription={customDescription}
        customSubtitle={customSubtitle}
      />
      <CtaSection secondary />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/service-areas',
  component: ServiceAreasPage,
});
